var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":_vm.delHandle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }